import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { UiUserMenuComponent } from './ui-user-menu/ui-user-menu.component';

@NgModule({
  imports: [CommonModule, TranslateModule, MatRippleModule, RouterModule, MatIconModule],
  declarations: [UiUserMenuComponent]
})
export class CoreFeatureUserMenuModule {}
